import { IState } from 'legacy/lut/store'

export const selectDevicesInfoState = (state: IState) => state.partner360.shareOfBusiness
